import React from 'react'
import styled, { keyframes } from 'styled-components';

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
`;

const LoadingAnimation = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  animation: ${spinAnimation} 1s infinite linear;
`;

const Loading = () => {
  return (
    <LoadingContainer>
      <LoadingAnimation />
    </LoadingContainer>
  )
}

export default Loading;
